import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgotPassword/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Toast
import toastReducer from "./toast/reducer";

import UsersReducer from "./users/reducer";
import OperatorsReducer from "./operators/reducer";

// Dashboard / Analytics
import LTDashboardReducer from "./lt/analytics/reducer";
import LT1DashboardReducer from "./lt1/analytics/reducer";
import LT3DashboardReducer from "./lt3/analytics/reducer";

// Settings
import LTSettingsReducer from "./lt/settings/reducer";
import LT1SettingsReducer from "./lt1/settings/reducer";
import LT3SettingsReducer from "./lt3/settings/reducer";
import ROSettingsReducer from "./ro/settings/reducer";
import SOSettingsReducer from "./sorat/settings/reducer";

// Joker Settings (Only Game 1)
import jokerSettingsReducer from "./lt/joker/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  toast: toastReducer,
  Users: UsersReducer,
  Operators: OperatorsReducer,

  // Game 1 (Lucky Target)
  lt: combineReducers({
    dashboard: LTDashboardReducer,
    settings: LTSettingsReducer,
    joker: jokerSettingsReducer,
  }),

  // Game 2 (Lucky Target 2)
  lt1: combineReducers({
    dashboard: LT1DashboardReducer,
    settings: LT1SettingsReducer,
  }),
  // Game 5 (Lucky Target 3)
  lt3: combineReducers({
    dashboard: LT3DashboardReducer,
    settings: LT3SettingsReducer,
  }),
  // Game 3 (American Roulette)
  ro: combineReducers({
    settings: ROSettingsReducer,
  }),
  // Game 4 (Sorat)
  so: combineReducers({
    settings: SOSettingsReducer,
  }),
});

export default rootReducer;

